export function getDataSourceStatic(key) {
  try {
    let data = {
      footerList: [
        {
          title: "平台协议",
          url: "https://storage.jd.com/protocols/format/2f4c7cc718135d2a8067e9230b3af814.html?_t=166813295129232",
          clstag: "DSGJ|85741"
        },
        {
          title: "帮助中心",
          url: "https://jrhelp.jd.com/show/getProblemInfo?id=688",
          clstag: "DSGJ|85769"
        },
        {
          title: "营业执照",
          url: "https://img14.360buyimg.com/imagetools/jfs/t1/146010/34/35387/537628/648a7179Fd4dfc96b/56dae54408f6bca8.png?v3",
          clstag: "DSGJ|85743"
        },
        {
          title: "小贷“十不准”",
          url: "https://storage.jd.com/protocols/format/b01c6c7c84fb5f2daf632d8b23e6a9f8.html",
          clstag: "DSGJ|85766"
        }
      ]
    }
    return data[key];
  } catch (error) {
    return null;
  }
}
